import { Modal, screenSize } from "@holta/ui";
import React, { ReactElement } from "react";
import styled from "styled-components";
import { Header } from "./parts/Header";
import { Sidebar } from "./parts/Sidebar";
import { fns, libTypes } from "@holta/lib";
import { ProductsTable } from "./parts/ProductsTable";
import { SupplierProductBrowserContextProvider, useSupplierProductBrowserContext } from "./context";
import { Footer } from "./parts/Footer";
import { FilterInput } from "./parts/FilterInput";

interface Props {
    modalId: string;
    suppliers: libTypes.Supplier[];
    products: libTypes.SupplierComputedProduct[];
    categories: libTypes.Category[];
    handleConfirm: (product: libTypes.SupplierComputedProduct) => void;
}

export const SupplierProductBrowser = ({ modalId, products, categories, suppliers, handleConfirm } : Props) : ReactElement | null => {

    return (
        <SupplierProductBrowserContextProvider categories={categories} suppliers={suppliers} products={products} handleConfirm={handleConfirm} modalId={modalId}>
            <ProductBrowserInner />
        </SupplierProductBrowserContextProvider>
    )
}

export const ProductBrowserInner = () => {
    const { modalId } = useSupplierProductBrowserContext();
    return (
        <S.Modal id={modalId} width="90vw">
            <>
                <Header />
                <S.ModalContentWrapper>
                    <Sidebar/>
                    <S.ModalBodyWrapper>
                        <FilterInput />
                        <ProductsTable />
                    </S.ModalBodyWrapper>
                </S.ModalContentWrapper>
                <Footer />
            </>
        </S.Modal>
    );
};

/* --------------------------------- Styles --------------------------------- */

const S = {
    Modal: styled(Modal)`
        height: 90vh;

        @media (min-width: ${screenSize.sm}px) {
            height: 85vh;
        }
    `,

    ModalContentWrapper: styled.div`
        flex-grow: 1;
        display: flex;
        overflow: hidden;
    `,

    ModalBodyWrapper: styled.div`
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    `,
};
